// Thin fetch wrapper around the Rails JSON API.

const qs = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "");
  if (!entries.length) return "";
  return "?" + entries.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
};

async function get(url) {
  const res = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" });
  if (!res.ok) throw new Error(`GET ${url} failed (${res.status})`);
  return res.json();
}

async function request(method, url, body) {
  const res = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

const post = (url, body) => request("POST", url, body);

export const api = {
  products: (params) => get("/api/v1/products" + qs(params)),
  tags: () => get("/api/v1/tags"),
  concerns: () => get("/api/v1/concerns"),
  concern: (slug) => get("/api/v1/concerns/" + encodeURIComponent(slug)),
  packages: () => get("/api/v1/packages"),
  testimonials: () => get("/api/v1/testimonials"),
  gallery: () => get("/api/v1/gallery"),
  settings: () => get("/api/v1/site_settings"),
  search: (q) => get("/api/v1/search" + qs({ q })),
  createOrder: (order) => post("/api/v1/orders", { order }),
  paymentStatus: (cid) => get("/api/v1/payments/status/" + encodeURIComponent(cid)),
  invoiceUrl: (reference) => "/api/v1/orders/" + encodeURIComponent(reference) + "/invoice",
  createContact: (contact_message) => post("/api/v1/contact_messages", { contact_message }),

  // Auth (cookie session)
  me: () => get("/api/v1/me"),
  signup: (user) => post("/api/v1/signup", { user }),
  login: (user) => post("/api/v1/login", { user }),
  logout: () => request("DELETE", "/api/v1/logout"),
  otpVerify: (code) => post("/api/v1/otp/verify", { code }),
  otpResend: (channel) => post("/api/v1/otp/resend", { channel }),
};
